<template>
  <Modal
    width="920"
    :title="title"
    class-name="c-document vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin size="large" fix v-if="show"></Spin>
    <Row class="filter-box" :gutter="12" v-if="state">
      <Col span="7">
        <Form :label-width="60">
          <FormItem label="创建人">
            <Select v-model="opId" placeholder="全部" clearable filterable>
              <Option v-for="item in opData" :value="item.opId" :key="item.opId">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <!-- <drop-autoComplete label="创建人" member :default-option="defaultOpenId" @on-change="changeOperator" /> -->
        </Form>
      </Col>
      <Col span="7">
        <Form :label-width="60">
          <FormItem label="游戏">
            <Select v-model="gameId" placeholder="全部" clearable filterable>
              <Option v-for="item in gameData" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
      </Col>
      <Col span="6">
        <Input v-model.trim="keyword" placeholder="请输入文案内容或ID" search enter-button @on-search="search" @on-enter="search"></Input>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table
          ref="table"
          height="440"
          stripe
          :columns="columns"
          :data="docDataList"
          @on-row-click="rowClick"
          @on-select="selectRow"
          @on-select-all="selectAll"
          @on-select-cancel="cancelRow"
          @on-select-all-cancel="cancelAll"
        ></Table>
        <Page class="page-index" show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" />
      </Col>
    </Row>
    <Row slot="footer" :gutter="12">
      <Button type="default" @click="$emit('on-cancel')">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </Row>
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, debounce } from '@/common/js/utils'
import { listPlanDocument } from '@/api/manage.model'
import { adGames, adPtom } from '@/api/common.model'
import columns from './columns.json'
export default {
  name: 'idocument',
  props: {
    value: {
      type: Boolean
    },
    openId: {
      type: [Number, String]
    },
    singleChoice: {
      type: Boolean
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.defaultData.length
    },
    title() {
      return `文案选择  ${this.len ? '(已选' + this.len + '条)' : ''}`
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.docDataList = []
        this.defaultData = [] // 选中的文案
        this.keyword = ''
        this.gameId = ''
        this.opId = ''
        this.pageIndex = 1
      } else if (!this.docDataList.length) {
        // this.getData()
        this.setOpenId()
      }
    },
    rowClick(data, index) {
      this.$refs.table.toggleSelect(index)
    },
    selectRow(selection, row) {
      const idx = this.docDataList.findIndex((ret) => ret.docId === row.docId)

      console.log('this.singleChoice output: ', this.singleChoice)
      // 单选
      if (this.singleChoice) {
        this.docDataList.forEach((ret) => {
          this.$set(ret, '_checked', false)
        })
        if (idx > -1) {
          this.$set(this.docDataList[idx], '_checked', true)
          this.defaultData = [row]
        }
      } else this.defaultData.push(row)
    },
    selectAll() {
      this.docDataList.forEach((ret) => {
        this.selectRow([], ret)
      })
    },
    cancelRow(selection, row) {
      const index = this.defaultData.findIndex((ret) => ret.id === row.id)
      if (index > -1) this.defaultData.splice(index, 1)
    },
    cancelAll() {
      this.docDataList.forEach((ret) => {
        this.cancelRow([], ret)
      })
    },
    search() {
      this.pageIndex = 1
      this.getData({ keyWord: this.keyword })
    },
    getData(search) {
      if (!this.state) return
      let params = {
        keyWord: this.keyword,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        gameId: this.gameId,
        opId: this.opId
      }
      if (search) params = Object.assign(params, search)

      this.show = true
      listPlanDocument(params).then((data) => {
        this.show = false
        if (data && isArray(data.list) && data.page_info) {
          const { total_number } = data.page_info
          this.total = total_number
          this.docDataList = data.list.map((ret) => {
            ret._checked = this.defaultData.map((met) => met.docId).includes(ret.docId)
            return ret
          })
        }
      })
    },
    preLoadData() {
      Promise.all([adGames(), adPtom({ authFlag: 1 })])
        .then((data) => {
          if (data) {
            const [gameData, opData] = data
            isArray(gameData) && (this.gameData = gameData)
            this.gameData.unshift({ id: 0, name: '通用' })
            isArray(opData) && (this.opData = opData)
          }
        })
        .catch((err) => console.log(err))
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-document')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
      this.opId = Number(this.defaultOpenId)
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changeOperator(meta) {
      this.opId = meta.id
    },
    save() {
      if (this.defaultData.length) {
        // 记录上次成功opId
        this.setOperatorStorage('select-document', this.opId || -1)
        this.$emit('on-select', this.defaultData)
      } else this.$Message.warning('您未选择一个文案')
    }
  },
  data() {
    return {
      show: null,
      keyword: '',
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      columns: columns,
      opId: '',
      gameId: '',
      gameData: [],
      opData: [],
      docDataList: [],
      defaultData: [],
      defaultOpenId: ''
    }
  },
  created() {
    this.preLoadData()
  },
  watch: {
    opId(nVal) {
      this.pageIndex = 1
      debounce(() => {
        this.getData()
      }, 800)()
    },
    gameId() {
      this.pageIndex = 1
      debounce(() => {
        this.getData()
      }, 800)()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-document {
  position: relative;

  .filter-box {
    margin-bottom: 15px;

    ::v-deep .ivu-form-item {
      margin-bottom: 0;
    }
  }

  .page-index {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
